/**
 * @fileoverview Agent definition for generate-custom-style-guide-v2.
 *
 * This agent synthesizes a custom writing style guide from various influences
 * including genre templates, writer templates, universe templates, writing samples,
 * and mixing board slider settings.
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'generate-custom-style-guide-v2',
  kind: 'primitive',
  name: 'Style Guide Synthesizer v2',
  description: 'Synthesizes a custom writing style guide from various influences.',
  category: 'style',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Improvement #4 + Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2024-06',
    lastUpdated: '2025-01',
    usedBy: [
      'StyleGuideComposer',
      'use-style-guide-composer.ts',
    ],
    usedInComposites: ['extract-styleguide-v2'],
    relatedAgents: [
      'style-analyzer-v2',
      'genre-detector-v2',
    ],
    taxonomyPath: 'meta.style.generation',
  },
};
